import React from 'react'
import PropTypes from 'prop-types'
import File from '#components/a/File'

import NachweisModal from './NachweisModal'

function RemoveableFile(props) {
  const {nachweis, isReadOnly} = props
  return (
    <div className="removeableFile">
      {!isReadOnly && (
        <button type="button" className="removeableFile__remove" onClick={() => props.onRemove(nachweis.id)} />
      )}
      <NachweisModal trigger={<File id={nachweis.nummer} />} nachweisId={nachweis.id} />
    </div>
  )
}

RemoveableFile.propTypes = {
  nachweis: PropTypes.shape({
    nummer: PropTypes.number,
    id: PropTypes.string,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
}

export default RemoveableFile
